import { Injectable } from '@angular/core';
import Lenis from 'lenis';

@Injectable({ providedIn: 'root' })
export class SmoothScrollService {
  private lenis?: Lenis;

  connect(lenis: Lenis): void {
    this.lenis = lenis;
  }

  disconnect(): void {
    this.lenis = undefined;
  }

  scrollToTop(): void {
    if (this.lenis) {
      this.lenis.scrollTo(0, {
        duration: .85,
        lock: false,
      });
      return;
    }

    window.scrollTo({
      top: 0,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }
}
